<template>
    <div class="contenu_content">
        <v-container>
            <component :is="currentActionType" v-if="currentActionType" mode="update" @edit-result="redirection">
                <h3 class="custom_text_type_augment">
                    Type d'augmentation
                </h3>
                <v-select v-model="select" :hint="`${select.descr ? select.descr: ''}`" :items="actionTypes"
                          solo item-text="name" item-value="desc" abel="Select" persistent-hint
                          return-object class="custom_select_type_augment" @change="modeUpdateTypeAction($event.type)" />
            </component>
        </v-container>
        <transition name="fade">
            <modal-story-delete-component v-if="storyMode === 'deleteComponent'" />
            <modal-ra-dom-delete-component v-if="raDomMode === 'deleteComponent'" />
            <modal-action-not-save v-if="mode === 'notSave'" />
        </transition>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { actionTypes } from '../global/actionTypes';

    export default {
        name: 'ActionsTabContent',
        components: {
            Redirection: () => import('./actionsList/Redirection'),
            Story: () => import('./actionsList/Story'),
            Ra3d: () => import('./actionsList/Ra3d'),
            RaDom: () => import('./actionsList/RaDom'),
            Viewer3d: () => import('./actionsList/Viewer3d'),
            Content360: () => import('./actionsList/Content360'),
            ModalStoryDeleteComponent: () => import('./modals/ModalStoryDeleteComponent'),
            ModalRaDomDeleteComponent: () => import('./modals/ModalRaDomDeleteComponent'),
            ModalActionNotSave: () => import('./modals/ModalActionNotSave')
        },
        data: () => ({
            select: {}
        }),
        computed: {
            ...mapGetters('actions', ['mode', 'currentActionType']),
            actionTypes: function () {
                return actionTypes.filter((x) => x.type !== 'disabled');
            },
            storyMode: function () {
                return this.$store.state.actions.story.mode;
            },
            raDomMode: function () {
                return this.$store.state.actions.raDom.mode;
            }
        },
        watch: {
            mode: function () {
                this.refreshSelectType();
            }
        },
        mounted () {
            this.refreshSelectType();
        },
        methods: {
            ...mapActions('actions', ['modeUpdateTypeAction']),
            redirection: function (e) {
                if (e) {
                    this.$router.push({
                        name: 'augmentations',
                        params: { experienceToken: this.$route.params.experienceToken }
                    });
                }
            },
            refreshSelectType: function () {
                let counter = 0;
                let timer = setInterval(() => {
                    let value = this.actionTypes.filter((item) => item.type === this.currentActionType)[0];
                    if (value) {
                        this.select = value;
                        clearInterval(timer);
                    } else if (counter > 3) {
                        this.$toasted.error('Error during loading! Please refresh');
                        clearInterval(timer);
                    }
                    counter++;
                }, 100);
            }
        }
    };
</script>

<style scoped>
    .container {
        padding: 25px;
        max-width: 100% !important;
    }

    .custom_text_type_augment {
        width: 100%;
        text-align: center;
        margin-bottom: 15px;
    }
</style>
